import { inject } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import type { CanActivateFn } from '@angular/router';
import { Router } from '@angular/router';
import { filter, first, map } from 'rxjs/operators';
import { AuthSessionStore } from '../+state';
import { navigateOrReport } from '../util/navigate-or-report.util';

/**
 * Route guard restricting activation to `zone` users (or `admin`).
 */
export const zoneGuard: CanActivateFn = () => {
  const authStore = inject(AuthSessionStore);
  const router = inject(Router);

  return toObservable(authStore.authenticationInitialized).pipe(
    filter((initialized): boolean => initialized),
    first(),
    map(() => {
      if (authStore.isZone() || authStore.isAdmin()) {
        return true;
      }
      navigateOrReport(router, ['/'], 'Navigation to home failed');
      return false;
    })
  );
};
